"use client"

import { ExternalLink } from "@/components/ui/external-link"
import { buildRoute } from "@/lib/routes"
import { retrieveUTMParams } from "@/lib/services/utm"
import { PSEUDO_ID_COOKIE } from "@/platform/api/constants"
import { getSessionCookie } from "@/platform/session/auth/get-session-cookie-client"
import { useClientSessionId } from "@/platform/session/auth/use-client-session-id"

export const HeroRegistrationButton = () => {
  const { isMounted } = useClientSessionId()

  if (!isMounted) {
    return null
  }

  return (
    <ExternalLink href={buildRoute.externalSignup(getSessionCookie(PSEUDO_ID_COOKIE) || "", retrieveUTMParams())}>
      <button className="font-manrope text-nelo-blue hover:bg-brand-muted rounded-full border-none bg-white px-3 py-2 text-center text-xs font-bold transition-opacity duration-300 focus:shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] md:px-6 md:py-3 md:text-base">
        Crea tu cuenta
      </button>
    </ExternalLink>
  )
}
